import { inject } from "@angular/core";
import type { ResolveFn } from "@angular/router";
import { SessionService } from "@kno2/core/session";
import { Organization, OrganizationsService } from "@kno2/data-access/organizations";

export const organizationResolver: ResolveFn<Organization> = async (route, state) => {
    const sessionService = inject(SessionService);
    const organizationService = inject(OrganizationsService);

    const organizationId = sessionService.profileData().organizationId;
    return await organizationService.getOrganizationAsync(organizationId);
};
